<mat-form-field class="license-editor">
    <mat-label>{{ 'DoctorSection.License' | translate}}:</mat-label>
    <input matInput [formControl]="control" autocomplete="off" name="license" ngDefaultControl [required]="true" />
    <mat-error *ngIf="control.errors?.maxlength" translate="DoctorSection.LicenceInvalidLength"
        [translateParams]="{maxLength: control.errors.maxlength?.requiredLength | translate}">
    </mat-error>
    <mat-error *ngIf="control.errors?.required" translate="DoctorSection.LicenseIsRequired"
        [translateParams]="{maxLength: control.errors.required?.requiredLength | translate}">
    </mat-error>
</mat-form-field>